import { getAccount, logout as httpLogout } from '@/services/appService';
import router from '@/router';
import { getLocalStorage } from '@/utils/windowUtils';
import churnService from '@/utils/churn360';
import tutorialService from '@/services/tutorialService';
import { APP_NAMES } from '@/utils/constants';

// const mobileMediaQuery = window.matchMedia('(max-width: 768px)');
// const smallDesktopQuery = window.matchMedia(
//   '(min-width: 769px) and (max-width: 1280px)'
// );

function getAccess(
  LAST_ACTIVE_APP,
  { baAccess, ahAccess, ovCompanyAccess, ovPrivateAccess }
) {
  if (LAST_ACTIVE_APP === APP_NAMES.ANDRAHAND && ahAccess) {
    return APP_NAMES.ANDRAHAND;
  }
  if (LAST_ACTIVE_APP === APP_NAMES.OVERLATELSER_COMPANY && ovCompanyAccess) {
    return APP_NAMES.OVERLATELSER_COMPANY;
  }
  if (LAST_ACTIVE_APP === APP_NAMES.OVERLATELSER_PRIVATE && ovPrivateAccess) {
    return APP_NAMES.OVERLATELSER_PRIVATE;
  }
  if (LAST_ACTIVE_APP === APP_NAMES.BYTESANSOKAN && baAccess) {
    return APP_NAMES.BYTESANSOKAN;
  }

  // If no known last active app then just check access and return first
  if (ahAccess) {
    return APP_NAMES.ANDRAHAND;
  }
  if (ovCompanyAccess) {
    return APP_NAMES.OVERLATELSER_COMPANY;
  }
  if (ovPrivateAccess) {
    return APP_NAMES.OVERLATELSER_PRIVATE;
  }
  if (baAccess) {
    return APP_NAMES.BYTESANSOKAN;
  }
  return APP_NAMES.BYTESANSOKAN;
}

async function initiate(ctx) {
  // ctx.dispatch('getAndsetScreenSize');

  const account = await getAccount();

  const isAuth = !!account;

  ctx.commit('setIsAuthenticated', isAuth);
  ctx.commit('setAccount', account);

  const LAST_ACTIVE_APP = getAccess(
    getLocalStorage('BA_ACTIVE_APP'),
    ctx.getters
  );

  const currentRouteMeta = router.currentRoute.value?.meta || {};
  const ahRoute = currentRouteMeta.ahRoute || false;
  const baRoute = currentRouteMeta.baRoute || false;
  const ovPrivateRoute = currentRouteMeta.ovPrivateRoute || false;
  const ovCompanyRoute = currentRouteMeta.ovCompanyRoute || false;

  const path = window.location.pathname;

  ctx.commit('setIsAuthenticated', isAuth);
  ctx.commit('setAccount', account);

  if (path.includes('logga-ut')) {
    // do nothing
  } else if (isAuth) {
    if (path.includes('logga-in')) {
      router.push('/');
    } else {
      let routeApp = null;
      if (ahRoute && ctx.getters.ahAccess) routeApp = APP_NAMES.ANDRAHAND;
      else if (baRoute && ctx.getters.baAccess)
        routeApp = APP_NAMES.BYTESANSOKAN;
      else if (ovPrivateRoute && ctx.getters.ovPrivateAccess)
        routeApp = APP_NAMES.OVERLATELSER_PRIVATE;
      else if (ovCompanyRoute && ctx.getters.ovCompanyAccess)
        routeApp = APP_NAMES.OVERLATELSER_COMPANY;

      const isModuleRoute =
        ahRoute || baRoute || ovPrivateRoute || ovCompanyRoute;

      await ctx.dispatch('updateActiveApp', routeApp || LAST_ACTIVE_APP);

      if (isModuleRoute && !routeApp) {
        router.push('/');
      }
    }

    if (account.landlordId) {
      await ctx.dispatch('syncTutorialSteps');
    }
    // try {
    //   await ctx.dispatch('initChurn360');
    // } catch {
    //   console.error('Failed to init churn');
    // }
  }

  ctx.commit('setIsReady', true);
}

async function logout() {
  await httpLogout();
  window.location.replace('/logga-in');
}

// async function getAndsetScreenSize({ state, commit }) {
//   let newSize = 'DESKTOP';

//   if (mobileMediaQuery.matches) {
//     newSize = 'MOBILE';
//   } else if (smallDesktopQuery.matches) {
//     newSize = 'DESKTOP_SMALL';
//   }

//   if (state.setScreenSize !== newSize) {
//     commit('setScreenSize', newSize);
//     window.dispatchEvent(new CustomEvent('new-size', { detail: newSize }));
//   }
// }

async function syncTutorialSteps(ctx) {
  let seenTutorials = await tutorialService.getUserTutorialsSeen();

  if (!seenTutorials) {
    return;
  }

  // We clear seen tutorials on seen to enable correct counting when
  // new tutorials are present (1 of 1 on new visits instead of 3 of 3)
  for (let tutorialId of seenTutorials) {
    ctx.commit('markSyncedTooltipAsSeen', tutorialId);
  }
}

const validateEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

async function initChurn360(ctx) {
  if (location.host.includes('localhost')) {
    return;
  }
  const { account } = ctx.state;
  if (!validateEmail(account.email)) {
    return;
  }
  await churnService.loadScript();
  await churnService.initialize(account.landlordId, account.email);
  await churnService.identify(
    {
      firstName: account.firstName,
      lastName: account.lastName,
      email: account.email
    },
    account.userId
  );
}

async function markTooltipAsSeen(ctx, { reference }) {
  if (!reference) {
    return;
  }

  ctx.commit('markTooltipAsSeen', reference);

  await tutorialService.addSeenTutorialStep(reference);
}

async function resetFirstPartOfTooltipsArray(ctx) {
  ctx.commit('resetFirstPartOfTooltipsArray');
}

async function resetSecondPartOfTooltipsArray(ctx) {
  ctx.commit('resetSecondPartOfTooltipsArray');
}

async function updateActiveApp(ctx, name) {
  ctx.commit('setActiveApp', name);
  localStorage.setItem('BA_ACTIVE_APP', name);
  await ctx.dispatch('tags/getTags', null, {
    root: true
  });
}

export default {
  initiate,
  logout,
  syncTutorialSteps,
  markTooltipAsSeen,
  resetFirstPartOfTooltipsArray,
  resetSecondPartOfTooltipsArray,
  initChurn360,
  updateActiveApp
};
